import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	refinementOptionSuggestedGroups: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	refinementOptionSuggestedGroups: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.group.refinement-option-suggested-groups',
		defaultMessage: 'Suggested Groups',
		description: 'Suggested Groups subtitle in issue navigator refinement dropdown',
	},
});
export default messages;
